import { useI18n } from '../i18n/context'
import type { Locale } from '../i18n/messages'

const OPTIONS: { locale: Locale; short: string; name: string }[] = [
  { locale: 'fr', short: 'FR', name: 'Français' },
  { locale: 'en', short: 'EN', name: 'English' },
]

/** FR / EN segmented switch; the current language is pressed. */
export function LanguageToggle() {
  const { locale, setLocale, t } = useI18n()
  return (
    <fieldset className="lang-switch">
      <legend className="visually-hidden">{t('language.label')}</legend>
      {OPTIONS.map((option) => (
        <button
          key={option.locale}
          type="button"
          lang={option.locale}
          aria-label={option.name}
          aria-pressed={locale === option.locale}
          onClick={() => setLocale(option.locale)}
        >
          {option.short}
        </button>
      ))}
    </fieldset>
  )
}
